import * as React from "react";
import SelectBox from "../../../components/commonComponents/Selectors/SelectBox";
import { Stack } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { checkCompanyId, fetchCompanies } from "../../../api_calls/userManagement";
import {
  checkRegionId,
  filterRegionsAndStores,
  loadActiveStores,
  loadRegions,
  loadStores,
  preSelectionOfStores,
} from "../../../api_calls/campaigns";
import { updateStateData } from "../../../Store/actions";
import MultiSelect from "../../../components/commonComponents/Selectors/MultiSelect";
import { TextButtonStyle } from "../../../components/commonComponents/Buttons/Styles";
import { padding } from "@mui/system";
import { DetailedSelectionIconWithTooltip } from "../../../api_calls/utils";

export default function StoreHierarchy({ fieldNames, fieldError, selectionInfo, setSelectionInfo, usedFor, readOnlyFlag, setIsDetailSelectionModalOpen, onDropdownClose }) {
  // console.log("store Hierarchy stores: ", availableStores)
  const currentStateData = useSelector((state) => state.userSelections);
  const dispatchAction = useDispatch();

  const handleFieldChange = (fieldData) => {
    dispatchAction(updateStateData(fieldData));
  };

  const onStoreSelection = (selectedOption) => {
    setSelectionInfo(prev => ({
      ...prev,
      selected_store_options: selectedOption,
    })); const storeSelections = [...selectedOption];
    let selectedStores = [];
    if (selectedOption.length !== 0) {
      selectedOption.forEach((storeInfo) => {
        if (storeInfo.id === "all") {
          currentStateData.filtered_stores.forEach((filteredInfo) => {
            if (filteredInfo.id !== "all") {
              selectedStores = [...selectedStores, filteredInfo.label];
            }
          });
        } else {
          selectedStores = [...selectedStores, storeInfo.label];
        }
      });
    }
    const selectedData = {
      [fieldNames.stores]: selectedStores,
      selected_store_options: storeSelections,
    };

    handleFieldChange(selectedData);
  };

  // const test = async () => {
  //   onStoreSelection(currentStateData?.selected_store_options);
  // }

  React.useEffect(() => {
    // load companies list
    // fetchCompanies();
    // load regions
    loadRegions().then((regInfo) => {
      //load stores
      if (usedFor === "clips") {
        filterRegionsAndStores("clips").then((info) => {
          // need to set default options if selection info is undefined
          preSelectionOfStores(selectionInfo, onStoreSelection);
        });
      } else {
        loadActiveStores().then((storeInfo) => {
          filterRegionsAndStores("pictures").then((info) => {
            // need to set default options if selection info is undefined
            preSelectionOfStores(selectionInfo, onStoreSelection);
          });
          //  picture_store also needs to be prefilled if the user can not change the available to field.
          // onStoreSelection(currentStateData?.selected_store_options);
        });
      }
      //dispatch default
      if (currentStateData?.selected_store_options?.length > 0) {
        const initialStores = currentStateData.selected_store_options
          .filter(store => store.id !== "all")
          .map(store => store.label);

        handleFieldChange({
          [fieldNames.stores]: initialStores,
          selected_store_options: currentStateData.selected_store_options,
        });
      }
    });
  }, []);

  // React.useEffect(() => {
  //   if (currentStateData?.selected_store_options) {
  //     onStoreSelection(currentStateData.selected_store_options);
  //   }
  // }, [currentStateData?.selected_store_options]); // This will run when the value changes and exists

  return (
    <Stack direction="column" spacing={0} width="100%">
      <MultiSelect
        label="Stores *"
        enableFullWidth={true}
        elemId={"storesDropDown"}
        readOnlyFlag={readOnlyFlag}
        options={typeof currentStateData.filtered_stores !== "undefined" ? currentStateData.filtered_stores : []}
        defaultVal={currentStateData.selected_store_options || []}
        selectionCheck={(option, value) => option.label === value.label}
        onBlurCall={onDropdownClose}
        onChangeCall={(selectedOption) => {
          onStoreSelection(selectedOption);
        }}
        fieldError={fieldError !== "" ? fieldError : ""}
        additionalIconWithTooltip={true}
        additionalIconMarkup={(setOpen) => {
          return DetailedSelectionIconWithTooltip((e) => {
            e.stopPropagation();
            setOpen(false);
            setIsDetailSelectionModalOpen(true);
          })
        }
        }
        allowDuplicates={true}
      />
    </Stack>
  );
}